import { useEffect, useRef } from 'react';

/**
 * A hook to track the previous n state values.
 * @param value The state value to keep track. Note that if the new state value is the same as the previous value, it is ignored.
 * @param count The number of state values to keep track of.
 */
export function usePrevious<T>(value: T, { count }: { count: number }): T[] {
	const ref = useRef<T[]>([]);

	useEffect(() => {
		if (ref.current[ref.current.length - 1] === value) {
			return;
		}

		// Keep the size of the array equal to the count
		ref.current = [...ref.current.slice(ref.current.length > count - 1 ? 1 : 0), value];
	}, [count, value]);

	return ref.current;
}
